import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { supabase } from "@/components/atomic-crm/providers/supabase/supabase";
import { ScoreBadge } from "@/components/atomic-crm/scoring/ScoreBadge";

export function RecentTierChanges() {
    const [changes, setChanges] = useState<any[]>([]);

    useEffect(() => {
        supabase.from("contact_scores")
            .select("*, contacts(first_name, last_name)")
            .order("scored_at", { ascending: false })
            .limit(10)
            .then(({ data }) => { if (data) setChanges(data); });
    }, []);

    if (changes.length === 0) return null;

    return (
        <Card>
            <CardHeader className="pb-2">
                <CardTitle className="text-base">Recent Scores</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-2">
                    {changes.map((c) => (
                        <div key={c.id} className="flex items-center justify-between text-sm">
                            <span>{c.contacts?.first_name} {c.contacts?.last_name}</span>
                            <div className="flex items-center gap-2">
                                <ScoreBadge score={c.total_score} tier={c.tier} />
                                <span className="text-xs text-muted-foreground">
                                    {new Date(c.scored_at).toLocaleDateString()}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    );
}
